import React, { createContext, useContext } from 'react';
import { Outlet } from 'react-router-dom';
import { getConfiguration } from '../../data/utils/configuration';
import { useFetch } from '../../data/fetch/useFetch';
import { parsePageDataAvertisingMobile } from '../../data/parsePageDataAdvertising';

export const BannerDataContext = createContext(null);

export function useBannerData() {
    return useContext(BannerDataContext);
}

export default function BannerDataProvider({ children }) {
    const conf = getConfiguration();

    const [isLoading, isError, data] = useFetch(conf.api.getPageDataAdvertisingMobile, null, (data) =>
        parsePageDataAvertisingMobile(data)
    );

    const content = children || <Outlet />;

    if (isLoading || isError) {
        return (
            <BannerDataContext.Provider value={null}>
                {content}
            </BannerDataContext.Provider>
        );
    }

    return (
        <BannerDataContext.Provider value={data}>
            {content}
        </BannerDataContext.Provider>
    );
}
